export default "__VITE_PUBLIC_ASSET__91f7f783__"